
export const fontStyles = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  lineHeight: '1.5em',
  fontWeight: '300'
};


export const h4Styles = {
  ...fontStyles,
  fontSize: '1.3rem'
};

export const pStyles = {
  ...fontStyles,
  fontSize: '.88rem',
};
